import { render, staticRenderFns } from "./OrderExecution.vue?vue&type=template&id=22350163&scoped=true&"
import script from "./OrderExecution.vue?vue&type=script&lang=js&"
export * from "./OrderExecution.vue?vue&type=script&lang=js&"
import style0 from "./OrderExecution.vue?vue&type=style&index=0&id=22350163&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22350163",
  null
  
)

export default component.exports